export default __webpack_public_path__ + "static/media/collection-img-sample2.3508ca28.png";